import type { PAYMENT_TYPES } from '../typings/payment.types';

export default class CheckoutRedirect {
    static RedirectToCheckout(apiBasePath: string, basketId: number, payment: PAYMENT_TYPES) {
        const searchParams = new URLSearchParams({ basketId: basketId.toString(), payment });
        window.location.href = `${apiBasePath}?${searchParams}`;
    }

    static RedirectToOrderComplete(apiBasePath: string, orderNumber: string, payment: PAYMENT_TYPES) {
        const searchParams = new URLSearchParams({
            showMarketingPreferences: 'true',
            trackConversion: 'true',
            payment,
        });
        window.location.href = `${apiBasePath}/order-complete/${orderNumber}?${searchParams}`;
    }
}
